
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import ManifestoSection from './components/ManifestoSection';
import ProductShowcase from './components/ProductShowcase';
import ThreeRegionsSection from './components/ThreeRegionsSection';

export default function HomePage() {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "狮虎堂",
    "alternateName": "中国狮虎堂中草药集团有限公司",
    "url": import.meta.env.VITE_SITE_URL,
    "logo": "https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/f35a59635442fe291a9bbc6026c2854c.jfif",
    "description": "中国狮虎堂中草药集团有限公司，融汇三地精粹，唤醒沉睡在你体内的原生力量。狮虎之魄，养傲然之生。",
    "foundingLocation": {
      "@type": "Place",
      "name": "香港"
    },
    "areaServed": ["中国", "香港", "云南", "泰国"],
    "knowsAbout": ["中草药", "男性养生", "传统医学", "健康产品"],
    "sameAs": []
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="狮虎堂 - 塑东方体魄，养狮虎人生"
        description="中国狮虎堂中草药集团有限公司，融汇三地精粹，唤醒沉睡在你体内的原生力量。狮虎之魄，养傲然之生。"
        keywords="狮虎堂,男性养生,中草药,香港公司,云南药材,泰国草本"
        ogImage="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/f35a59635442fe291a9bbc6026c2854c.jfif"
        schema={homeSchema}
      />
      <Header />
      <main>
        <HeroSection />
        <ManifestoSection />
        <ProductShowcase />
        <ThreeRegionsSection />
      </main>
      <Footer />
    </div>
  );
}
